<template>
    <div>
        <header-component v-if="width > 1050"></header-component>
        <hamburger-component v-else></hamburger-component>
        <main-component v-bind:gender="gender" v-bind:areaId="areaId"></main-component>
        <contact-component></contact-component>
        <footer-component></footer-component>
    </div>
</template>

<script>
import Vue from 'vue'
import HeaderComponent from './common/HeaderComponent'
import HamburgerComponent from './common/HamburgerComponent'
import MainComponent from "./clinics/MainComponent.vue"
import ContactComponent from './common/ContactComponent'
import FooterComponent from './common/FooterComponent'
Vue.component('header-component', HeaderComponent)
Vue.component('hamburger-component', HamburgerComponent)
Vue.component('main-component', MainComponent)
Vue.component('contact-component', ContactComponent)
Vue.component('footer-component', FooterComponent)
export default ({
    props: ['gender', 'areaId'],
    data() {
        return {
            width: this.$store.state.width
        }
    },
    mounted() {
        window.addEventListener('resize', this.resizeWindow)
    },
    methods: {
        resizeWindow() {
            this.width = window.outerWidth
        }
    },
    head: {
        title: {
            inner: 'エミナルクリニックグループ総合サイト',
            separator: '|',
            complement: 'クリニック一覧'
        },
        meta: [
            { name: 'description', content: 'エミナルクリニックグループ総合サイト｜脱毛・美肌治療を全国展開。高品質な医療サービスで美容をサポートします。' }
        ]
    },
    components: {
        HeaderComponent,
        MainComponent,
        ContactComponent,
        FooterComponent,
    }
})
</script>